import { useAppSelector } from '@app/redux/hooks';
import { Grid } from '@ui-kit/Grid';
import { WrapperColumn } from './WrapperColumn';

import styles from './FooterLeft.module.scss';

export const FooterLeft = (): JSX.Element => {
  const { footer } = useAppSelector(state => state.header.data.headerMenu);
  return (
    <Grid className={styles.Container} row>
      {footer?.map(item => {
        return <WrapperColumn key={item?.title} {...item} />;
      })}
    </Grid>
  );
};
